export default function () {
  const noHover = window.matchMedia('(hover: none)').matches

  if (noHover) {
    document.body.classList.add('no-hover')
  }
}



// WEBPACK FOOTER //
// ./themes/default/js/modules/mobileDevices.js